<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="渠道名称">
              <j-input
                placeholder="请输入渠道名称"
                v-model="queryParam.name"
              ></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <wechatApp-modal ref="modalForm" @ok="modalFormOk"></wechatApp-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import WechatAppModal from './modules/SysChannelModal';

export default {
  name: 'WechatAppList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    WechatAppModal,
  },
  data() {
    return {
      description: 'WECHAT_APP管理页面',
      wechatApp: [],
      queryParam: {},
      // 表头
      columns: [
        {
          title: '渠道名字',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '渠道类型',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '渠道代码',
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: '关联微信账号',
          align: 'center',
          dataIndex: 'linkWechat',
          customRender: function (text) {
            return text;
          },
        },
        {
          title: '是否需要审核',
          align: 'center',
          dataIndex: 'needAudit_dictText',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text;
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/list',
        delete: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/deleteBatch',
        exportXlsUrl: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/importExcel',
      },
      dictOptions: {},
    };
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
  },
  created() {},
  methods: {
    initDictConfig() {},
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
